import { UserRight } from '../Interface_Enums';

//import * as Interface_Enums from 'app/ts/Interface_Enums'
export class InsufficientRights {
  constructor(public readonly userRight: UserRight) {}
}
